/* eslint-disable arrow-body-style, max-len */
import axios from 'axios';

const authToken = 'Basic YWxpY2Utd2ViOnNOdTFZdnBXbmh1UE9Kc0NvdVQyTHVWYU9Ua3lCeTEy';

function getCookieData(name) {
  let result = '';
  const cookies = document.cookie ? document.cookie.split('; ') : [];
  for (let i = 0; i < cookies.length; i += 1) {
    const d = cookies[i].split('=');
    if (d[0] === name && d[1]) {
      result = decodeURIComponent(d[1]);
      break;
    }
  }
  return result;
}

let aliceUrl = '/alice-api';
let setUpUrl = '/setup';
let aliceApiServiceUrl = '/alice-api-service';
const appPath = getCookieData('app_path');
if (appPath) {
  aliceUrl = `${appPath}/alice-api`;
  setUpUrl = `${appPath}/setup`;
  aliceApiServiceUrl = `${appPath}/alice-api-service`;
}

const permission = {
  home: ['user', 'admin', 'developer', 'superuser'],
  train: ['user', 'admin', 'developer', 'superuser'],
  understanding: ['user', 'admin', 'developer', 'superuser'],
  storyboard: ['user', 'admin', 'superuser'],
  condition: ['user', 'admin', 'developer', 'superuser'],
  model: ['admin', 'developer', 'superuser'],
  rulebased: ['user', 'admin', 'developer', 'superuser'],
  nlpconfig: ['user', 'admin', 'developer', 'superuser'],
  files: ['user', 'admin', 'developer', 'superuser'],
  logs_export: ['admin', 'superuser'],
  faq_report_export: ['admin', 'superuser'],
  promotion_tracking_export: ['admin', 'superuser'],
  one_on_one_chat: ['user', 'admin', 'superuser'],
  line_broadcast: ['admin', 'developer', 'superuser'],
  create_line_broadcast: ['admin', 'developer', 'superuser'],
  model_setting: ['admin', 'developer', 'superuser'],
  user_manager: ['admin', 'superuser'],
  promotions: ['user', 'admin', 'developer', 'superuser'],
  value_editor: ['user', 'admin', 'developer', 'superuser'],
  test_set_editor: ['admin', 'developer', 'superuser'],
  benchmark: ['admin', 'developer', 'superuser'],
  conversation_editor: ['admin', 'developer', 'superuser'],
  satisfaction: ['admin', 'developer', 'superuser'],
  activitylog: ['admin', 'developer', 'superuser'],
  nps: ['admin', 'developer', 'superuser'],
};

function logoutFn() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('user');
  localStorage.removeItem('vuex');
  localStorage.removeItem('username');
  if (appPath) {
    window.location = `${appPath}/login`;
  } else {
    window.location = '/login';
  }
}

function invalidArray(input) {
  if (input === null) {
    return true;
  }
  if (typeof input === 'undefined') {
    return true;
  }
  if (input.length === 0) {
    return true;
  }
  return false;
}

function isHttps(input) {
  return /^(https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(input);
}

function apiRequest(url, method, path, data, params) {
  return axios
    .request({
      method,
      url: `${url}/${path}`,
      data,
      params,
    })
    .catch((e) => {
      // console.log(e.request);
      if (e.response && e.response.status && e.response.status === 401) {
        logoutFn();
      } else if (e.status && e.status === 401) {
        logoutFn();
      } else {
        throw e;
      }
    });
}

function getReq(path, params) {
  return apiRequest(aliceUrl, 'get', path, undefined, params);
}

function delReq(path, params) {
  return apiRequest(aliceUrl, 'delete', path, undefined, params);
}

function delReqWithBody(path, data, params) {
  return apiRequest(aliceUrl, 'delete', path, data, params);
}

function postReq(path, data, params) {
  return apiRequest(aliceUrl, 'post', path, data, params);
}

function putReq(path, data, params) {
  return apiRequest(aliceUrl, 'put', path, data, params);
}

// Permission
function getPermission(role, route) {
  if (permission[route]) {
    return permission[route].includes(role);
  }
  return false;
}

// prettier-ignore
export default {
  appPath,
  // Login
  login: (username, password) => {
    const formData = new FormData();
    formData.append('grant_type', 'password');
    formData.append('username', username);
    formData.append('password', password);
    return axios.request({
      method: 'post',
      url: `${aliceUrl}/oauth/token`,
      data: formData,
      headers: {
        Authorization: authToken,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },
  login_setup: (token) => axios.request({
    method: 'post',
    url: setUpUrl,
    data: {
      token,
    },
  }),
  logout: () => {
    logoutFn();
  },
  setAccessToken: (accessToken) => {
    localStorage.setItem('accessToken', accessToken);
  },
  setUser: (userData) => {
    const str = JSON.stringify(userData);
    localStorage.setItem('user', str);
  },
  getUser: () => {
    const str = localStorage.getItem('user');
    const userData = JSON.parse(str);
    return userData;
  },
  getUsername: () => {
    const str = localStorage.getItem('user');
    const userData = JSON.parse(str);
    if (userData && userData.username) {
      return userData.username;
    }
    return '';
  },
  getUserInfo: () => getReq('security/current-user-info'),
  hasPermission: (role, route) => getPermission(role, route),
  // Config file
  createConfigFile: (configData) => postReq('nlp/config/create', configData),
  createPartialConfig: (configData) => postReq('nlp/config/partial', configData),
  getAllConfigFile: () => getReq('nlp/config/get'),
  getConfigFile: (configId) => getReq(`nlp/config/${configId}`),
  getPartialConfigWithChild: (configId) => getReq(`nlp/config/partial/${configId}/with-child`),
  getPartialConfigByPartialConfigParentId: (configId) => getReq(`/nlp/config/partial-by-parent/${configId}`),
  updateConfigFile: (configId, configData) => putReq(`nlp/config/${configId}`, configData),
  updatePartialConfig: (configId, updateConfigData) => putReq(`nlp/config/partial/${configId}`, updateConfigData),
  deleteConfigFile: (configId) => delReq(`nlp/config/${configId}`),
  deletePartialConfig: (configId) => delReq(`nlp/config/partial/${configId}`),
  reloadChatServerState: (configId) => getReq('nlp/config/reload', { id: configId }),

  // Bot State
  loadStateData: () => getReq('bot-state'),
  updateState: (stateData) => putReq(`bot-state/${stateData.stateId}`, stateData),
  addStateData: (stateData) => postReq('bot-state', stateData),
  removeStateData: (stateId) => delReq(`bot-state/${stateId}`),
  // Model
  loadModelList: () => getReq('nlp/model'),
  predict: (modelId, text) => postReq(`nlp/model/${modelId}/predict`, [text]),
  createModel: (modelData) => postReq('nlp/model', modelData),
  updateModel: (modelId, modelData) => putReq(`nlp/model/${modelId}`, modelData),
  updateModelOrder: (modelIdList) => putReq('nlp/model/update-model-order', modelIdList),
  deleteModel: (modelId) => delReq(`nlp/model/${modelId}`),
  // Category
  loadModelCategory: (modelId) => getReq(`nlp/model/${modelId}`),
  loadCategoryList: (modelId) => getReq(`nlp/model/${modelId}/category`),
  createCategory: (modelId, categoryData) => postReq(`nlp/model/${modelId}/category`, categoryData),
  updateCategory: (modelId, categoryId, categoryData) => putReq(`nlp/model/${modelId}/category/${categoryId}`, categoryData),
  deleteCategory: (modelId, categoryId) => delReq(`nlp/model/${modelId}/category/${categoryId}`),
  // Question
  loadTrainedMessageList: (modelId, categoryId) => getReq(`nlp/model/${modelId}/category/${categoryId}`),
  loadTrainedMessagePage: (modelId, categoryId, page, size, searchPhrase) => getReq(`nlp/model/${modelId}/category/${categoryId}/question/get-page`, {
    page,
    size,
    'search-phrase': searchPhrase,
  }),
  trainModel: (modelId) => postReq(`nlp/model/${modelId}/train`),
  trainAllModel: () => postReq('nlp/model/train-all'),
  createQuestion: (modelId, categoryId, question) => postReq(`nlp/model/${modelId}/category/${categoryId}/question`, { question }),
  updateQuestion: (modelId, categoryId, questionId, question) => putReq(`nlp/model/${modelId}/category/${categoryId}/question/${questionId}`, { question }),
  deleteQuestion: (modelId, categoryId, questionId) => delReq(`nlp/model/${modelId}/category/${categoryId}/question/${questionId}`),
  // To be train
  checkMessageStatus: (modelId, message) => getReq('to-be-train/message-status', { 'model-id': modelId, message }),
  getPageToBeTrainMessage: (modelId, categoryId, page, size) => getReq(`to-be-train/${modelId}/category/${categoryId}/question/get-to-be-train-page`, {
    page,
    size,
  }),
  createToBeTrainMessage: (modelId, categoryId, message) => postReq(`to-be-train/${modelId}/category/${categoryId}/to-be-train/`, { message }),
  moveToTrainMessage: (modelId, categoryId) => postReq(`to-be-train/${modelId}/category/${categoryId}/to-train`),
  updateToBeTrainMessage: (messageId, data) => putReq(`to-be-train/${messageId}`, data),
  deleteToBeTrainMessage: (messageId) => delReq(`to-be-train/${messageId}`),
  getTotalToBeTrainCount: () => getReq('to-be-train/total-count'),
  // Rule base
  loadRuleSet: () => getReq('rule-base/rule-set/'),
  createRuleSet: (name) => postReq('rule-base/rule-set/', { name }),
  loadRulesBySet: (setId) => getReq(`rule-base/rule-set/${setId}/rule`),
  createRule: (setId, data) => postReq(`rule-base/rule-set/${setId}/rule`, data),
  saveRuleAnswerFromId: (ruleId, data) => putReq(`rule-base/rule/${ruleId}/answers`, data),
  saveRuleKeywordFromId: (ruleId, data) => putReq(`rule-base/rule/${ruleId}/keywords`, data),
  saveRuleTagFromId: (ruleId, data) => putReq(`rule-base/rule/${ruleId}/tags`, data),
  deleteRuleSet: (setId) => delReq(`rule-base/rule-set/${setId}`),
  deleteRule: (ruleId) => delReq(`rule-base/rule/${ruleId}`),
  validateAnswer: (answer) => {
    if (answer.type === 'send_any_message') {
      if (invalidArray(answer.text)) {
        return {
          state: false,
          reason: 'Action should contain at least one message.',
        };
      }
      let valid = true;
      for (let i = 0; i < answer.text.length; i += 1) {
        const ans = answer.text[i].trim();
        if (ans.length === 0) {
          valid = false;
          break;
        }
      }
      if (!valid) {
        return {
          state: false,
          reason: 'Message should not be empty.',
        };
      }
    } else if (answer.type === 'button_template') {
      if (invalidArray(answer.title)) {
        return {
          state: false,
          reason: 'Title should not be empty.',
        };
      }
      if (invalidArray(answer.text)) {
        return {
          state: false,
          reason: 'Text should not be empty.',
        };
      }
      if (invalidArray(answer.buttons)) {
        return {
          state: false,
          reason: 'Template should contain at least one button.',
        };
      }
    } else if (answer.type === 'send_image') {
      if (invalidArray(answer.url)) {
        return {
          state: false,
          reason: 'Url should not be empty.',
        };
      }
      if (!isHttps(answer.url)) {
        return {
          state: false,
          reason: 'Url must be https://.',
        };
      }
    } else if (answer.type === 'send_video' || answer.type === 'send_audio') {
      if (invalidArray(answer.url)) {
        return {
          state: false,
          reason: 'Url should not be empty.',
        };
      }
      if (!isHttps(answer.url)) {
        return {
          state: false,
          reason: 'Url must be https://.',
        };
      }
      if (!answer.playable) {
        return {
          state: false,
          reason: 'Media type is not support or not available.',
        };
      }
    }
    return {
      state: true,
    };
  },
  matchRuleBase: (setId, text, parent) => getReq(`rule-base/rule-set/${setId}/match?text=${text}&parent=${parent}`),
  // Rule base tag
  searchRuleTag: (page = 0, size = 10, value) => postReq(`rule-base-tag/search?page=${page}&size=${size}&value=${value}`),
  // Logs
  exportExcelLogs: (sinceDate, untilDate, direction, channel, clientId) => axios.request({
    method: 'post',
    url: `${aliceUrl}/log/export/excel`,
    responseType: 'blob',
    data: {
      sinceDate,
      untilDate,
      direction,
      channel,
      clientId,
    },
  }),
  loadLogList: (size, channel, page, userSearch) => postReq('log/getUserList', {
    size,
    channel,
    page,
    sort: { direction: 'DESC' },
    userSearch,
  }),
  loadLogDetail: (userId, size, page, channel) => postReq('log/getLog', {
    size,
    channel,
    page,
    userId,
    sort: { direction: 'DESC' },
  }),
  loadAvailableChannel: () => postReq('log/get-available-channel'),

  exportLogExcelToFile: (data) => axios.request({
    method: 'post',
    url: `${aliceUrl}/log/export/excel-to-file`,
    responseType: 'blob',
    data,
  }),
  getAllLogZipFileDetail: () => getReq('log/file'),
  downloadLogZipFile: (fileId) => axios.request({
    method: 'get',
    url: `${aliceUrl}/log/file/${fileId}/download`,
    responseType: 'blob',
  }),
  getAllActiveLogZipFileDetail: () => getReq('log/file/active'),
  deleteDownloadFile: (id) => delReq(`log/file/${id}`),
  // downloadLogZipFile: (fileId) => getReq(`log/file/${fileId}/download`),

  // faq report
  getAllFaqReportZipFileDetail: () => getReq('log/faq-report/file'),
  getAllActiveFaqReportZipFileDetail: () => getReq('log/faq-report/file/active'),
  downloadFaqReportZipFile: (fileId) => axios.request({
    method: 'get',
    url: `${aliceUrl}/log/faq-report/file/${fileId}/download`,
    responseType: 'blob',
  }),
  // exportFaqReportToFile: (data) => axios.request({
  //   method: 'post',
  //   url: `${aliceUrl}/log/faq-report/export`,
  //   responseType: 'blob',
  //   data,
  // }),
  exportFaqReportToFile: (data) => postReq('log/faq-report/export', data),
  deleteFaqReportDownloadFile: (id) => delReq(`log/faq-report/file/${id}`),

  // promotion tracking report
  getAllPromotionTrackingReportFileDetail: () => getReq('promotion/promotion-tracking-report/file'),
  getAllActivePromotionTrackingReportFileDetail: () => getReq('promotion/promotion-tracking-report/file/active'),
  downloadPromotionTrackingReportFile: (fileId) => axios.request({
    method: 'get',
    url: `${aliceUrl}/promotion/promotion-tracking-report/file/${fileId}/download`,
    responseType: 'blob',
  }),
  exportPromotionTrackingReportToFile: (data) => postReq('promotion/promotion-tracking-report/export', data),
  deletePromotionTrackingReportDownloadFile: (id) => delReq(`promotion/promotion-tracking-report/file/${id}`),

  // Issues
  searchIssues: (size, page, status) => postReq('issue/search', { size, page, status }),
  resolveIssue: (id, type) => putReq('issue/resolve', { type }, { 'issue-id': id }),
  markResolveIssue: (id) => putReq('issue/mark-as-resolved', {}, { 'issue-id': id }),
  deleteIssue: (id) => delReq('issue/delete', { 'issue-id': id }),
  createIssue: (text) => postReq('issue/create', { text }),
  // Users
  getUserList: () => getReq('user-info/user'),
  addAdmin: (userData) => postReq('user-info/admin', userData),
  addUser: (userData) => postReq('user-info/user', userData),
  updateUser: (userId, userData) => putReq(`user-info/user/${userId}`, userData),
  deleteUser: (userId) => delReq(`user-info/${userId}`),
  // Usage
  getIncomingMessageHistory: (criteria) => postReq('usage/incoming-message/history', criteria),
  getActiveUserHistory: (criteria) => postReq('usage/active-user/history', criteria),
  getActiveUser: (criteria) => postReq('usage/active-time', criteria),
  getExportActiveUser: (data) => axios.request({
    method: 'post',
    url: `${aliceUrl}/usage/active-user-and-active-time/export`,
    responseType: 'blob',
    data,
  }),
  getMessageCategoryStat: (criteria) => postReq('usage/message-category', criteria),
  getFlowStat: (criteria) => postReq('usage/flow-usage', criteria),
  getRuleBaseMatchStat: (criteria) => postReq('usage/rule-base-match', criteria),
  getBotKnowledge: () => postReq('usage/bot-knowledge'),
  getBotPerformance: (criteria) => postReq('usage/bot-performance', criteria),
  getTotalUser: (criteria) => postReq('usage/total-user', criteria),
  getTrendingTopics: (criteria) => postReq('usage/flow-usage/history', criteria),
  exportDailyUser: (criteria) => axios.request({
    method: 'post',
    url: `${aliceUrl}/usage/active-user/export`,
    responseType: 'blob',
    data: criteria,
  }),
  exportActiveTime: (criteria) => axios.request({
    method: 'post',
    url: `${aliceUrl}/usage/active-time/export`,
    responseType: 'blob',
    data: criteria,
  }),
  getGenerativeAIUsageHistory: (criteria) => postReq('generative-ai-usage/history', criteria),
  getGenerativeAIUsagePromptLog: (requestBody) => postReq('generative-ai-usage/list', requestBody),
  exportGenerativeAIUsage: (criteria) => axios.request({
    method: 'post',
    url: `${aliceUrl}/generative-ai-usage/export`,
    responseType: 'blob',
    data: criteria,
  }),

  // Satisfaction
  createForm: (data) => postReq('satisfaction/create', data),
  getForm: () => getReq('satisfaction/'),
  deleteFrom: (documentId) => delReq(`satisfaction/delete/${documentId}`),
  getFormSummary: () => getReq('satisfaction/summary'),
  getFormSummaryWithFilter: (searchBody) => postReq('satisfaction/summary', searchBody),
  getFormWithFilter: (searchBody) => postReq('satisfaction/', searchBody),
  // exportSatisfactionForm: (satisfactionExportBody) => postReq('satisfaction/export', satisfactionExportBody),
  exportSatisfactionForm: (satisfactionExportBody) => axios.request({
    method: 'post',
    url: `${aliceUrl}/satisfaction/export`,
    responseType: 'blob',
    data: satisfactionExportBody,
  }),
  // nps
  createNPSForm: (data) => postReq('nps/form/create', data),
  getNPSForm: () => getReq('nps/form'),
  getNPSFormWithFilter: (searchBody) => postReq('nps/form', searchBody),
  getNPSSummaryWithFilter: (searchBody) => postReq('nps/form/summary', searchBody),
  exportNpsForm: (searchBody) => {
    return axios.request({
      method: 'post',
      url: `${aliceUrl}/nps/form/export`,
      responseType: 'blob',
      data: searchBody,
    });
  },
  // Promotions
  getPromotion: (activeOnly) => getReq('promotion', { 'active-only': activeOnly }),
  getPromotionById: (promotionId) => getReq(`promotion/${promotionId}`),
  createNewPromotion: (data) => postReq('promotion', { ...data }),
  updatePromotion: (promotionId, data) => putReq(`promotion/${promotionId}`, { ...data }),
  deletePromotion: (promotionId) => delReq(`promotion/${promotionId}`),
  importPromotion: (formData) => axios.request({
    method: 'post',
    url: `${aliceUrl}/promotion/import`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  exportPromotion: (language) => axios.request({
    method: 'get',
    url: `${aliceUrl}/promotion/export?language=${language}`,
    responseType: 'blob',
  }),
  // Collections - Key - Values pair config
  getCollection: () => getReq('key-value/'),
  createCollection: (collectionName, keyName, sourceType) => postReq('key-value/', { collectionName, keyName, sourceType }),
  deleteCollection: (collectionId) => delReq(`key-value/${collectionId}`),
  importCollection: (formData) => axios.request({
    method: 'post',
    url: `${aliceUrl}/key-value/import`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  updateCollectionDisplayName: (name, id) => axios.request({
    method: 'put',
    url: `${aliceUrl}/key-value/${id}`,
    data: `{"collectionDisplayName": "${name}"}`,
    headers: {
      authorization: 'Basic aW5zaWdodGVyYXVzZXI6MW41MWdodEVyYT8=',
      'content-type': 'application/json',
    },
  }),
  exportCollectionById: (collectionId) => axios.request({
    method: 'get',
    url: `${aliceUrl}/key-value/${collectionId}/export`,
    responseType: 'blob',
  }),
  getKeyValuePage: (collectionId, size, page, searchPhrase) => {
    const opt = { size, page };
    if (searchPhrase && searchPhrase.length > 0) {
      opt['search-phrase'] = searchPhrase;
    }
    return getReq(`key-value/${collectionId}/key-value`, opt);
  },
  addKeyValue: (collectionId, key, value) => postReq(`key-value/${collectionId}/key-value`, [{ collectionId, key, value }]),
  updateKeyValue: (collectionId, id, data) => putReq(`key-value/${collectionId}/key-value/${id}`, data),
  deleteKeyValue: (collectionId, id) => delReq(`key-value/${collectionId}/key-value/${id}`),
  getCollectionHeaderById: (collectionId) => getReq(`key-value/${collectionId}/header`),
  // Chat Server
  // getIsBotActive: (data) => postReq('chat-server-call', { path: 'bot/is-bot-active', data }),
  // activateBot: (data) => postReq('chat-server-call', { path: 'bot/activate', data }),
  // deactivateBot: (data) => postReq('chat-server-call', { path: 'bot/deactivate', data }),
  // sendChatMessages: (data) => postReq('chat-server-call', { path: 'messenger/send-messages', data }),
  getIsBotActive: (data) => postReq('alice-service/bot/is-bot-active', { path: 'bot/is-bot-active', data }),
  activateBot: (data) => postReq('alice-service/bot/activate', { path: 'bot/activate', data }),
  deactivateBot: (data) => postReq('alice-service/bot/deactivate', { path: 'bot/deactivate', data }),
  sendChatMessages: (data) => postReq('alice-service/messenger/send-messages', { path: 'messenger/send-messages', data }),
  // Media
  listFile: (data) => getReq('media/file', { ...data }),
  getFileInfo: (id) => getReq(`media/file/${id}`),
  getUsage: () => getReq('media/usage'),
  uploadFile: (data) => postReq('media/upload', data),
  deleteFile: (id) => delReq(`media/file/${id}`),
  uploadUrl: `${aliceUrl}/media/upload`,
  // Test Sets - Key - Values
  listTestSet: () => getReq('test-set/'),
  listTestSetBenchId: (benchmarkId) => getReq('test-set/', { 'benchmark-id': benchmarkId }),
  createTestSet: (name, benchmarkId) => postReq('test-set/', { name, benchmarkId }),
  deleteTestSet: (setId) => delReq(`test-set/${setId}`),
  createTestSetEntry: (setId, entryList) => postReq(`test-set/${setId}/create-entries`, entryList),
  updateTestSetEntry: (setId, entryId, data) => putReq(`test-set/${setId}/update-entry/${entryId}`, data),
  getTestSetEntryPage: (setId, page, size, data) => postReq(`test-set/${setId}/search-entry-page`, data, { page, size }),
  deleteTestSetEntry: (setId, entryId) => delReq(`test-set/${setId}/delete-entries`, { 'entry-id': entryId }),
  // Benchmark
  listBenchmark: () => getReq('benchmark/'),
  createBenchmark: (name, funnel) => postReq('benchmark/', { name, funnel }),
  testBenchmark: (benchmarkId, testSetId) => postReq(`benchmark/${benchmarkId}/test`, {}, { 'test-set-id': testSetId }),
  getBenchmarkResultPage: (benchmarkId, page, size, baseline) => getReq(`benchmark/${benchmarkId}/test`, { page, size, baseline }),
  getBenchmarkRawResultPage: (benchmarkId, testId, page, size, filterData) => postReq(`benchmark/${benchmarkId}/test/${testId}`, filterData, {
    page,
    size,
  }),
  setBenchmarkTestResultBaseline: (benchmarkId, testId) => putReq(`benchmark/${benchmarkId}/test/${testId}/set-baseline?baseline=true`),
  // Conversation Editor
  getConversationSet: () => getReq('conversation/string'),
  getConversationSetByName: (name) => getReq('conversation/string/conversation-string-object', { 'conversation-string-set-name': name }),
  setConversationString: (setId, data) => postReq(`conversation/string/${setId}/conversation-string`, data),
  // Server Dashboard config
  getServerDashboardConfig: () => getReq('server-dashboard-config'),
  // log LDD
  exportNotUnderstand: (sinceDate, untilDate, status) => axios.request({
    method: 'post',
    url: `${aliceApiServiceUrl}/issue/export`,
    // url: 'https://chatmordin.ldd.go.th/alice-api-service/issue/export',
    responseType: 'blob',
    headers: {
      authorization: 'Basic aW5zaWdodGVyYXVzZXI6MW41MWdodEVyYT8=',
      'content-type': 'application/json',
    },
    data: {
      sinceDate,
      untilDate,
      status,
    },
  }),
  // activity log
  activityLog: (data) => postReq('alice-activity-log/', data),
  // line broadcast
  getLineBroadcastJob: (data) => postReq('line-broadcast-job/', data),
  createLineBroadcastJob: (data) => postReq('line-broadcast-job/create', data),
  deleteLineBroadcastJob: (jobId) => delReq(`line-broadcast-job/${jobId}`),
  getEstimateTargetReach: (target, date) => getReq(`line-broadcast-job/estimate-target-reach?target=${target}&date=${date}`),
  exportRecipientsCustomGroup: (jobId) => axios.request({
    method: 'get',
    url: `${aliceUrl}/line-broadcast-job/${jobId}/export-custom-group`,
    responseType: 'blob',
  }),
  uploadMediaMessage: (formData) => axios.request({
    method: 'post',
    url: `${aliceUrl}/line-broadcast-job/media/upload`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  archiveLineBroadcastJob: (jobId) => axios.request({
    method: 'patch',
    url: `${aliceUrl}/line-broadcast-job/${jobId}/archive`,
  }),
  checkAutomaticArchive: () => getReq('line-broadcast-job/check-automatic-archive'),

  // Knowledge File
  getKnowledgeFileList: (size, type, after) => postReq('knowledge-files/files', { size, type, after }),
  uploadKnowledgeFile: (formData) => axios.request({
    method: 'post',
    url: `${aliceUrl}/knowledge-files/upload`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  deleteKnowledgeFile: (id, fileType) => delReqWithBody(`knowledge-files/files/${id}`, { type: fileType }),
  downloadKnowledgeFile: (id, fileType) => axios.request({
    method: 'get',
    url: `${aliceUrl}/knowledge-files/files/${id}/download`,
    params: { type: fileType },
    responseType: 'blob',
  }),
  getKnowledgeFileFieldDescriptions: (id, fileType) => getReq(`knowledge-files/files/${id}/field-descriptions`, { type: fileType }),
  updateKnowledgeFileFieldDescriptions: (id, fileType, data) => putReq(`knowledge-files/files/${id}/field-descriptions`, data, { type: fileType }),
  replaceKnowledgeFile: (id, formData) => axios.request({
    method: 'put',
    url: `${aliceUrl}/knowledge-files/files/${id}`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
};
